var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import classNames from "classnames";
import styles from "./Styles.module.css";
export function MainLayout(_a) {
    var children = _a.children, className = _a.className, fillContainer = _a.fillContainer, rest = __rest(_a, ["children", "className", "fillContainer"]);
    return (React.createElement("div", __assign({ className: classNames("relative mx-auto my-0 flex h-screen w-screen max-w-[100vw] grow flex-col items-center justify-center overflow-hidden leading-tight", {
            "desktop:h-[608px] desktop:min-h-[536px] desktop:max-w-[360px] desktop:rounded-[10px]": !fillContainer,
        }, className) }, rest), children));
}
export function Overlay(_a) {
    var children = _a.children, className = _a.className, fillContainer = _a.fillContainer, rest = __rest(_a, ["children", "className", "fillContainer"]);
    return (React.createElement("div", __assign({ className: classNames("static left-0 top-0 flex h-auto w-full items-start overflow-auto tall:items-center tall:overflow-hidden", {
            "desktop:fixed desktop:h-full desktop:pb-[4%] desktop:pt-[2%]": !fillContainer,
        }, className) }, rest), children));
}
export function Label(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("label", __assign({ className: classNames("mb-[5px] flex cursor-pointer justify-between rounded-[5px] border-2 border-solid border-white border-opacity-[0.15] bg-white bg-opacity-10 p-[10px]", className) }, rest), children));
}
export function LabelButton(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("button", __assign({ className: classNames("mb-2 flex w-full justify-between rounded-lg border-2 border-solid border-white border-opacity-[0.15] bg-white bg-opacity-10 p-4 text-base text-current shadow-[0_2px_4px_-1px_rgba(0,0,0,0.2),0_4px_5px_0_rgba(0,0,0,0.14),0_1px_10px_0_rgba(0,0,0,0.12)]", className) }, rest), children));
}
export function ContainerFull(_a) {
    var children = _a.children, className = _a.className, centerVertically = _a.centerVertically, rest = __rest(_a, ["children", "className", "centerVertically"]);
    return (React.createElement("div", __assign({ "data-cy": "container-full", className: classNames("flex grow flex-col items-center self-stretch overflow-hidden rounded-[10px]", {
            "justify-center": centerVertically,
            "justify-start": !centerVertically,
        }, className, styles.containerFull) }, rest), children));
}
export function Subtitle(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: classNames("mb-4 box-border w-full px-6 md:h-[100px] short:h-1/5", className) }, rest), children));
}
export function FullWidthForm(_a) {
    var children = _a.children, className = _a.className, buttonToBottom = _a.buttonToBottom, rest = __rest(_a, ["children", "className", "buttonToBottom"]);
    return (React.createElement("form", __assign({ className: classNames("mx-6 mb-8 flex grow flex-col items-center self-stretch", {
            "mb-[30px] justify-between": buttonToBottom,
        }, className) }, rest), children));
}
export function Submit(_a) {
    var children = _a.children, className = _a.className, color = _a.color, bgColor = _a.bgColor, style = _a.style, disabled = _a.disabled, rest = __rest(_a, ["children", "className", "color", "bgColor", "style", "disabled"]);
    return (React.createElement("button", __assign({ className: classNames("flex h-14 w-full items-center justify-center rounded border-0 px-4 py-1 text-center text-xl shadow-[0_4px_8px_0_rgba(0,0,0,0.1),inset_0_1px_0_0_rgba(255,255,255,0.1)] outline-[0] transition-shadow duration-200 ease-in-out hover:shadow-[0_8px_8px_0_rgba(0,0,0,0.2),inset_0_1px_0_0_rgba(255,255,255,0.15)] disabled:opacity-50", {
            "hover:cursor-default": disabled,
            "hover:cursor-pointer": !disabled,
        }, className), style: __assign({ color: color, backgroundColor: bgColor }, style) }, rest), children));
}
export function MultiQuoteHeading(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: classNames("text-center text-[22px] font-bold text-[#14141C]", className) }, rest), children));
}
